/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import PageTabs from '@/components/PageTabs'
import { useTranslation } from '@sailor/i18n-web'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import StaffTab from '@/pages/staff'
import DepartmentTab from '@/pages/department'
import GroupTab from '@/pages/group'
import CostCenterTab from '@/pages/cost-center'
import ExpenseCodeTab from '@/pages/expense-code'
import entInfoAtom from '@/common/recoil/atom/entInfoAtom'

const { Pane: TabPane } = PageTabs

type TabKey = 'staff' | 'department' | 'group' | 'costCenter' | 'expenseCode'

const TAB_QUERY_KEY = 'tab'

export default () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const entInfo = entInfoAtom.useData()

  const allTabs: TabKey[] = [
    'staff',
    'department',
    'group',
    ...(entInfo?.costCenterEnabled ? ['costCenter' as TabKey] : []),
    ...(entInfo?.expenseCodeEnabled ? ['expenseCode' as TabKey] : []),
  ]

  const getTabFromQuery = (): TabKey => {
    const params = new URLSearchParams(location.search)
    const tab = params.get(TAB_QUERY_KEY) as TabKey
    return allTabs.includes(tab) ? tab : 'staff'
  }

  const [activeTab, setActiveTab] = useState<TabKey>(getTabFromQuery)

  // 当 URL query 中 tab 参数变化时同步 activeTab
  useEffect(() => {
    setActiveTab(getTabFromQuery())
  }, [location.search])

  const handleTabClick = (name: string) => {
    const tab = name as TabKey
    setActiveTab(tab)
    navigate(`/enterprise?${TAB_QUERY_KEY}=${tab}`, { replace: true })
  }

  return (
    <div className={`page-content ${styles.enterprisePage}`}>
      <div className="page-title">
        {t('e_pc_enterprise_mgmt', '企业管理')}
      </div>
      <PageTabs
        value={activeTab}
        onTabClick={handleTabClick}
        style={{ marginTop: '24px' }}
      >
        <TabPane label={t('staff_title', '员工管理')} name="staff" />
        <TabPane label={t('e_pc_dept_mgmt', '部门管理')} name="department" />
        <TabPane label={t('e_pc_group_mgmt', '分组管理')} name="group" />
        {entInfo?.costCenterEnabled && (
          <TabPane label={t('e_pc_cost_center_tab', '成本中心')} name="costCenter" />
        )}
        {entInfo?.expenseCodeEnabled && (
          <TabPane label={t('e_pc_expense_code_label', '费用代码')} name="expenseCode" />
        )}
      </PageTabs>
      <div className={styles.tabContent}>
        {activeTab === 'staff' && <StaffTab />}
        {activeTab === 'department' && <DepartmentTab />}
        {activeTab === 'group' && <GroupTab />}
        {activeTab === 'costCenter' && <CostCenterTab />}
        {activeTab === 'expenseCode' && <ExpenseCodeTab />}
      </div>
    </div>
  )
}
